
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin6Fill } from "react-icons/ri";

import { CommonContext } from "../../../App";
import AddButton from "../../../Components/CommonComponent/Button/AddButton";
import Pagination, { usePagination } from "../../../Components/CommonComponent/Pgination/pagination";
import AddAreaModal from "../../../Components/CommonComponent/Modals/AddAreaModal";
import DeleteDataModal from "../../../Components/CommonComponent/Modals/DeleteDataModal";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router";
import { IoArrowUndoSharp } from "react-icons/io5";
import api from "../../../services/api";
import LoadingSpinner from "../../../Components/CommonComponent/loadingSpiner/LoadingSpinner";

export default function AreasTable() {

  const { branchId } = useContext(CommonContext);

  const [areas, setAreas] = useState({ allData: [], pagination: { totalRecords: 0 } });
  const [loading, setLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedArea, setSelectedArea] = useState(null);
  const [modalDelete, setModalDelete] = useState(false);
  const {t} = useTranslation();
  const storedLang = JSON.parse(localStorage.getItem("second_language"));
  const language = storedLang?.language || "en";

  // ✅ Use same pagination hook as in ManagerTable
  const {
    currentPage,
    itemsPerPage,
    handlePageChange,
    handleItemsPerPageChange,
    getPaginatedData,
  } = usePagination(10);

  const paginationData = getPaginatedData(areas);

  // 🟢 Fetch areas from backend
  const fetchAreas = async () => {
    try {
      setLoading(true);
      const res = await api.get(`area/get-all?page=${currentPage}&limit=${itemsPerPage}&branchId=${branchId}`);
      if (Array.isArray(res.data)) {
        setAreas({
          allData: res.data,
          pagination: { totalRecords: res.data.length },
        });
      } else if (res.data?.data) {
        setAreas({
          allData: res.data.data,
          pagination: res.data.pagination || { totalRecords: res.data.data.length },
        });
      } else {
        toast.error("Unexpected response format");
      }
    } catch (err) {
      toast.error("Failed to fetch areas");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (branchId) fetchAreas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchId,currentPage,itemsPerPage]);

const handleDelete = async () => {
  try {
    const res = await api.post(`area/delete/${selectedArea.id}`, {
       branchId 
    });

    if (res.data.success) {
      toast.success("Area deleted successfully");
      fetchAreas();
    } else {
      toast.error(res.data.message || "Failed to delete area");
    }
  } catch (err) {
    toast.error("Server error while deleting area");
    console.error(err);
  } finally {
    setModalDelete(false);
    setSelectedArea(null);
  }
};


  return (
    <div className="py-2 flex justify-center">
      <div className="w-full flex flex-col">
        <div>
           <NavLink
            to="/web-setting"
            title="Back to groups table"
            // state={{ typeName: selectedGroupType }}
            className="border inline-block p-1 px-2 text-theme-headerBg rounded hover:bg-theme-headerBg hover:text-theme-color cursor-pointer"
          >
            <IoArrowUndoSharp />
          </NavLink>
        </div>
        {/* Header */}
        <div className="flex justify-between items-center  bg-theme-headerBg py-1 px-2 text-theme-color">
          <div className=" font-medium  text-sm">{t("transportationRates(Area wise)")}</div>
          <AddButton
            text={t("add")}
            onClick={() => {
              setSelectedArea(null);  
              setShowAddModal(true);
            }}  
          />
        </div>

        {/* Table */}
        {loading ? (
          <div className="text-center text-gray-500 py-4">
             <div className="flex justify-center my-4">
                          <LoadingSpinner size={70} />
                        </div>
          </div>
        ) : paginationData.currentItems.length === 0 ? (
          <p className="text-center text-gray-500 text-sm italic py-4">
           {t("noDataAvailable")}
          </p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full   text-sm">
              <thead>
                <tr className="bg-theme-tableBg text-theme-headerBg border-theme-headerBg">
                  <th className="border-b text-center px-1">{t("srNumber")}</th>
                  <th className="border-b py-[2px] px-1 text-center">{t("areaName")}</th>
                  <th className="border-b px-1 text-center">{t("transportationRate")} (₹)</th>
                  <th className="border-b px-1 text-center">{t("actions")}</th>
                </tr>
              </thead>
              <tbody>
                {paginationData.currentItems.map((a, i) => (
                  <tr key={a.id} className="bg-theme-tableBg hover:bg-theme-tableHoverColor">
                    <td className="border-b py-[2px] text-center px-1">
                      {(currentPage - 1) * itemsPerPage + i + 1}
                    </td>
                    <td className="border-b py-[2px] px-1 text-center">{a.name} {language !== "en" && a.name_in_hindi && ` (${a.name_in_hindi})`}</td>
                    <td className="border-b py-[2px] px-1 text-center">{a.price}</td>
                    <td className="border-b py-[2px] px-1 text-center">
                      <div className="flex justify-center gap-2">
                        <FaEdit
                          className="cursor-pointer hover:text-blue-500"
                          title="Edit Area"
                          onClick={() => {
                            setSelectedArea(a);
                            setShowAddModal(true);
                          }}
                        />
                        <RiDeleteBin6Fill
                          className="text-red-700 cursor-pointer hover:text-red-800"
                          title="Delete Area"
                          onClick={() => {
                            setSelectedArea(a);
                            setModalDelete(true);
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* ✅ Pagination Component (same as ManagerTable) */}
            <Pagination
              data={areas}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleItemsPerPageChange}
              itemsPerPageOptions={[10, 20, 50]}
              showPageInfo
            />
          </div>
        )}
      </div>

      {/* Add / Edit Modal */}
      {showAddModal && (
        <AddAreaModal
          onClose={() => setShowAddModal(false)}
          onAreaSaved={() => fetchAreas()}
          selectedArea={selectedArea}
          addMultiple={true}
        />
      )}

      {/* Delete Modal */}
      {modalDelete && (
        <DeleteDataModal
          selectedLedger={selectedArea}
          handleDeleteModalClose={() => setModalDelete(false)}
          handleDeleteLedgerApi={handleDelete}
        />
      )}
    </div>
  );
}
